import { render, staticRenderFns } from "./TabVisitors.vue?vue&type=template&id=542e4a1a&scoped=true&"
import script from "./TabVisitors.vue?vue&type=script&lang=ts&"
export * from "./TabVisitors.vue?vue&type=script&lang=ts&"
import style0 from "./TabVisitors.vue?vue&type=style&index=0&id=542e4a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542e4a1a",
  null
  
)

component.options.__file = "TabVisitors.vue"
export default component.exports